import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'
import {
  PageContainer,
  LayoutContainer,
  SidebarContainer,
  SidebarHeader,
  ContentArea,
} from '../../../Pages/styles/SettingsPageStyles'

const MENU_ITEMS = [80, 60, 72, 90]

export function SkeletonSettings() {
  return (
    <PageContainer $isMobile={false}>
      <LayoutContainer>
        {/* Sidebar */}
        <SidebarContainer>
          <SidebarHeader>
            <SkeletonBox $width="72px" $height="18px" $radius={BORDER_RADIUS.sm} />
          </SidebarHeader>
          <div
            style={{
              padding: `${SPACING.sm} ${SPACING.sm}`,
              display: 'flex',
              flexDirection: 'column',
              gap: SPACING.xs,
            }}
          >
            {MENU_ITEMS.map((w, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: SPACING.sm,
                  padding: `${SPACING.sm} ${SPACING.sm}`,
                  height: '36px',
                }}
              >
                <SkeletonBox
                  $width="16px"
                  $height="16px"
                  $radius={BORDER_RADIUS.sm}
                  style={{ flexShrink: 0 }}
                />
                <SkeletonBox $width={`${w}px`} $height="14px" $radius={BORDER_RADIUS.sm} />
              </div>
            ))}
          </div>
        </SidebarContainer>

        {/* Content area */}
        <ContentArea $isMobile={false} $hasDesktopSidebar={true}>
          <SkeletonBox
            $width="180px"
            $height="22px"
            $radius={BORDER_RADIUS.sm}
            style={{ marginBottom: SPACING.xl }}
          />
          {[null, null, null].map((_, i) => (
            <div key={i} style={{ marginBottom: SPACING.lg }}>
              <SkeletonBox
                $width="100px"
                $height="13px"
                $radius={BORDER_RADIUS.sm}
                style={{ marginBottom: SPACING.xs }}
              />
              <SkeletonBox $width="100%" $height="36px" $radius={BORDER_RADIUS.lg} />
            </div>
          ))}
          <SkeletonBox
            $width="100px"
            $height="36px"
            $radius={BORDER_RADIUS.lg}
            style={{ marginTop: SPACING.md }}
          />
        </ContentArea>
      </LayoutContainer>
    </PageContainer>
  )
}
